<section class="relative bg-surface-100 dark:bg-surface-950 min-h-180">
	<div class="relative h-152 w-full">
		<div class="absolute inset-0 bg-black/40 dark:bg-black/60 z-10"></div>
		@if (content.image){
		<img
			fill
			class="w-full h-full object-cover"
			[ngSrc]="content.image.src"
			[alt]="content.image.alt"
			priority />
		}
	</div>

	<div class="absolute inset-0 flex flex-col items-center justify-start px-6 lg:px-8 z-30">
		<div class="flex flex-col items-center text-center mt-10 lg:mt-40">
			@if (content.title.length > 0){
			<h1
				class="text-4xl lg:text-6xl font-bold text-surface-0 leading-tight"
				[innerHTML]="content.title"></h1>
			} @if (content.description.length > 0){
			<h2
				class="mt-4 text-lg lg:text-xl text-surface-0 max-w-xl leading-normal"
				[innerHTML]="content.description"></h2>
			}
		</div>

		<div class="w-full lg:max-w-3xl mt-10 lg:mt-16 bg-primary-500 dark:bg-surface-900 shadow-xl">
			<div class="p-6 lg:p-8">
				<div class="flex flex-col gap-6">
					<app-offer-form></app-offer-form>
				</div>
			</div>
		</div>
	</div>
</section>
